import request from '@/api/request';
import store from '@/store';

function get(url) {
  return new Promise((resolve) => {
    request.get(url).then((res) => {
      resolve(res.data);
    });
  });
}

const products = () => {
  const url = '/api/product/mix';
  return new Promise((resolve) => {
    if (store.state.productMixInfo.length > 0) {
      resolve(store.state.productMixInfo);
    } else {
      request.get(url).then((res) => {
        store.commit('SET_PMI', res.data);
        resolve(res.data);
      });
    }
  });
};

const productDetail = (id) => {
  const url = `/api/product/${id}`;
  return get(url);
};

const awards = () => {
  const url = '/api/default/awards';
  return get(url);
};

const recommenNews = () => {
  const url = '/api/news/list?is_fixed=1';
  return get(url);
};

const commonNews = (page) => {
  const url = `/api/news/list?page=${page}`;
  return get(url);
};

const initNews = () => Promise.all([
  recommenNews(), commonNews(1),
]);

const newsDetail = (id) => {
  const url = `/api/news/${id}`;
  return get(url);
};

const jobs = () => {
  const url = '/api/job/list';
  return get(url);
};

const slides = (type) => {
  let url;
  switch (type) {
    case 'home':
    case 'about':
    case 'contact':
      url = `/api/imgs/${type}`;
      break;
    default:
      url = null;
      break;
  }
  if (url) {
    return get(url);
  }
  return Promise.reject(new Error('请求错误'));
};

const cinfo = () => {
  const url = '/api/default/contacts';
  return get(url);
};

export {
  products,
  productDetail,
  awards,
  recommenNews,
  commonNews,
  initNews,
  newsDetail,
  jobs,
  slides,
  cinfo,
};
